import { Link } from 'react-router-dom';
import { FolderKanban } from 'lucide-react';
import { useProjects } from '@/api/projects';
import { ProgressBar, ProjectStatusChip, fmtDay } from './ProjectKit';
import { projectPath } from '@/lib/routes';

/**
 * Ticket side rail: the project a ticket belongs to (`Tickets.projectID`). Reads the cached projects list,
 * so it costs no extra Autotask call. Renders nothing when the ticket has no project.
 */
export function ProjectTicketCard({ projectId }: { projectId: number | null | undefined }) {
  const { data } = useProjects();
  if (projectId == null) return null;
  const p = data?.projects.find((x) => x.id === projectId);
  return (
    <div className="rounded-lg border border-border bg-card px-4 py-3 shadow-sm">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground"><FolderKanban className="h-3.5 w-3.5" /> Project</div>
      {p ? (
        <>
          <Link to={projectPath(p.id)} className="mt-1.5 block text-sm font-medium text-foreground hover:underline">{p.name}</Link>
          <div className="mt-1 flex items-center gap-2 text-[11px] text-muted-foreground"><span className="font-mono">{p.number}</span><ProjectStatusChip status={p.status} /></div>
          <ProgressBar pct={p.progress.pct} className="mt-2" />
          <div className="mt-1 text-[11px] text-muted-foreground">Lead {p.leadName ?? '—'} · ends {fmtDay(p.end)}</div>
          <p className="mt-1.5 text-[11px] text-muted-foreground">Project tickets are for set-up (contract + project). Log project work on its tasks.</p>
        </>
      ) : (
        <Link to={projectPath(projectId)} className="mt-1.5 block text-sm text-foreground hover:underline">Open project #{projectId}</Link>
      )}
    </div>
  );
}
